import { useLocation, useSearch } from "wouter";

export function useQueryParam(key: string) {
  const [location, setLocation] = useLocation();
  const queryString = useSearch();
  const params = new URLSearchParams(queryString);
  const onChange = (val: string | null) => {
    if (val === null) {
      params.delete(key);
    } else {
      params.set(key, val);
    }
    const newLocation = `${location}?${params.toString()}`;
    setLocation(newLocation);
  };

  return [params.get(key), onChange] as const;
}
